export class Espece {
    static jsonMap = {
        id: 'id',
        code: { key: 'code', optional: true },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    id: number;
    code: string;
    libelle: string;
}
